module.exports = __webpack_public_path__ + "static/media/girl-member.aafd34d2.svg";